import React from "react";
import RatingModal from "./RatingModal";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { addToHistory, savePost, removeSavedPost } from '../../store/slices/postSlice';
import { postApi } from '../../services/api/postApi';
import { detailPostInterface } from "../../types/post.type";
import { toast } from 'react-toastify'; // Import toast
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles

interface OptionMovieProps {
  episodeTotal: number;
  likeCount: number;
  ratingAvg: number;
  onPlay: () => void;
  isPlaying: boolean;
  post: detailPostInterface;
}
const OptionMovie: React.FC<OptionMovieProps> = ({
  episodeTotal,
  likeCount,
  ratingAvg,
  onPlay,
  isPlaying,
  post,
}) => {
  const [showRatingModal, setShowRatingModal] = React.useState(false);
  const [rating, setRating] = React.useState(0); // số sao đã chọn
  const [hoverRating, setHoverRating] = React.useState(0); // số sao đang hover
  const [reviewText, setReviewText] = React.useState("");

  const dispatch = useDispatch();
  const savedPosts = useSelector((state: RootState) => state.post.savedPosts);
  const viewedHistory = useSelector((state: RootState) => state.post.viewedHistory);
  const token = useSelector((state: RootState) => state.auth.token); // Assuming token is stored in auth slice

  React.useEffect(() => {
    if (post && post.id) {
      dispatch(addToHistory(post));
    }
  }, [post, dispatch]);

  const isSave = React.useMemo(() => {
    return post && post.id && !!savedPosts.find((item: any) => item.id === post.id);
  }, [savedPosts, post]);

  const isLike = React.useMemo(() => {
    return post && post.id && !!viewedHistory.find((item: any) => item.id === post.id && item.isLike);
  }, [viewedHistory, post]);

  const handleSave = () => {
    if (isSave) {
      dispatch(removeSavedPost(post.id));
    } else {
      dispatch(savePost(post));
    }
  };

  const handleLike = async () => {
    if (post && post.id) {
      const newLike = !isLike;
      try {
        await postApi.likePostApi(post.id, post.posttype, { like: newLike ? 1 : 2 });
        dispatch(addToHistory({ ...post, isLike: newLike }));
        toast.success(newLike ? "Đã thích bài viết!" : "Đã bỏ thích bài viết!");
      } catch (error) {
        console.error("Error liking post:", error);
        toast.error("Có lỗi xảy ra khi thích bài viết!");
      }
    }
  };

  const handleShare = () => {
    const shareData = {
      title: post?.title || "Movie",
      text: `Check out this movie: ${post?.title || "Movie"}`,
      url: window.location.href,
    };

    if (navigator.share) {
      navigator.share(shareData).catch((error) => console.error("Error sharing:", error));
    } else {
      console.log("Web Share API not supported. Fallback to custom share logic.");
      // Implement fallback logic for unsupported browsers if needed
    }
  };

  const handleRatingSubmit = async () => {
    if (!token) {
      toast.warn("Bạn cần đăng nhập để đánh giá!");
      return;
    }

    if (post && post.id) {
      
      try {
        await postApi.ratingPostApi(post.id, post.posttype, { rating, content: reviewText });
        setShowRatingModal(false);
        setRating(0);
        setReviewText("");
        toast.success("Đánh giá của bạn đã được gửi!");
      } catch (error) {
        console.error("Error submitting rating:", error);
        toast.error("Có lỗi xảy ra khi gửi đánh giá!");
      }
    }
  };

  const buttons = [
    {
      label: isLike ? "Đã Thích" : "Thích",
      icon: isLike ? "/assets/like.svg" : "/assets/icons/like.svg",
      onClick: handleLike,
    },
    {
      label: "Đánh giá",
      icon: "/assets/icons/rating-icon.svg",
      onClick: () => setShowRatingModal(true),
    },
    {
      label: isSave ? "Đã Lưu" : "Lưu",
      icon: isSave ? "/assets/icons/saved.svg" : "/assets/icons/add.svg",
      onClick: handleSave,
    },
    {
      label: "Chia sẻ",
      icon: "/assets/icons/share.svg",
      onClick: handleShare,
    },
  ];

  return (
    <div className="main-info-2 max-h-[70vh] w-full flex flex-col items-center justify-center text-center gap-1 md:gap-4 px-2 md:px-8">
      <RatingModal
        open={showRatingModal}
        rating={rating}
        hoverRating={hoverRating}
        reviewText={reviewText}
        onClose={() => setShowRatingModal(false)}
        onRatingChange={setRating}
        onHoverRatingChange={setHoverRating}
        onReviewTextChange={setReviewText}
        onSubmit={handleRatingSubmit}
      />
      <div className="w-full flex justify-between items-center container h-auto py-2 md:py-3">
        {buttons.map((button, index) => (
          <button
            key={index}
            className="flex justify-center items-center text-white flex-col gap-1 md:gap-2"
            onClick={button.onClick}
          >
            <div className="w-[36px] h-[36px] md:w-[60px] md:h-[60px] flex justify-center items-center bg-[#292929] rounded-full hover:bg-[#FF4D00]/80 transition-all duration-300">
              <img 
                src={button.icon} 
                alt={button.label} 
                className="w-3 h-3 md:w-auto md:h-auto" 
              />
            </div>
            <span className="text-[8px] md:text-xs">{button.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default OptionMovie;
